import { type ICompanyMemberQuery } from 'application/querySchemas/ICompanyMemberQuery';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { type ICompanyMemberListClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/ICompanyMemberListClient';
import {
    type ICompanyUserClient,
    IGetResponse as ICompanyUserResponse,
} from 'interfaceAdapter/gatewaySchemas/ICompanyUserClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class CompanyMemberQuery implements ICompanyMemberQuery {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanyMemberListClient')
        public readonly companyMemberListClient: ICompanyMemberListClient,
        @inject('ICompanyUserClient')
        public readonly companyUserClient: ICompanyUserClient,
    ) {}

    public async fetchList(): Promise<IGetResponse['data']> {
        const { data, message } = await this.companyMemberListClient.get({
            token: this.companyUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }

    public async fetchUser(userId: number): Promise<ICompanyUserResponse['data']> {
        const { data, message } = await this.companyUserClient.get({
            token: this.companyUserToken.get() || '',
            userId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
